import { useEffect } from "react";
import Container from "../Container/Container";
import { getCompanyData, loadFavicon } from "../../utils";
import { useAppSelector } from "../../app/hooks";
import styles from "./FallbackPage.module.scss";

//Assets
import WorkingImage from "../../assets/images/technicalErrorPage.svg?react";

interface AppStatus {
  maintenance: boolean;
  technicalProblems: boolean;
}

interface Props {
  appStatus?: AppStatus | null;
}

const FallbackPage = ({ appStatus }: Props) => {
  const { container, cardContainer, companyIcon } = styles;
  const { language } = useAppSelector((state) => state.securities);

  const { logo, favicon } = getCompanyData();

  const renderTechnicalProblemsContent = () =>
    language === "es" ? (
      <>
        <p>Estamos teniendo problemas técnicos.</p>
        <p>
          Nuestro equipo está trabajando para solucionarlo lo antes posible.
        </p>
        <p>Disculpá las molestias.</p>
      </>
    ) : (
      <>
        <p>We are experiencing technical issues.</p>
        <p>Our team is working to resolve it as soon as possible.</p>
        <p>We apologize for the inconvenience.</p>
      </>
    );
  const renderMaintenanceContent = () =>
    language === "es" ? (
      <>
        <p>Estamos realizando tareas de mantenimiento.</p>
        <p>Disculpá las molestias. En breve vas a poder ingresar.</p>
      </>
    ) : (
      <>
        <p>We are performing maintenance tasks.</p>
        <p>
          We apologize for the inconvenience. You will be able to log in
          shortly.
        </p>
      </>
    );

  const renderContent = () => {
    if (appStatus?.technicalProblems) {
      return renderTechnicalProblemsContent();
    }
    if (appStatus?.maintenance) {
      return renderMaintenanceContent();
    }
    return null;
  };

  useEffect(() => {
    if (favicon) {
      loadFavicon(favicon);
    }
  }, [favicon]);

  return (
    <Container className={container}>
      <img src={logo} className={companyIcon} />
      <div className={cardContainer}>
        <WorkingImage />
        {renderContent()}
      </div>
    </Container>
  );
};

export default FallbackPage;
